import { useEffect } from 'react';
import Lenis from 'lenis';

// 관성(이너셔) 있는 부드러운 스크롤. 기본 옵션은 실제 window를 그대로 스크롤하므로
// window.scrollY / 'scroll' 이벤트를 쓰는 useScrollY 등 기존 로직과 그대로 호환된다.
export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 0.6,
      easing: (t) => 1 - Math.pow(1 - t, 3),
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}
